import AddAHoliday from '~/components/growth_wizard/getting_started/substeps/AddAHoliday.vue';
import ApproveATimeOffRequest from '~/components/growth_wizard/getting_started/substeps/ApproveATimeOffRequest.vue';
import ApproveATimesheet from '~/components/growth_wizard/getting_started/substeps/ApproveATimesheet.vue';
import ConnectPayroll from '~/components/growth_wizard/getting_started/substeps/ConnectPayroll.vue';
import CreateASmartNotification from '~/components/growth_wizard/common/substeps/CreateASmartNotification.vue';
import CreateTeams from '~/components/growth_wizard/getting_started/substeps/CreateTeams.vue';
import DownloadTheDesktopApp from '~/components/growth_wizard/getting_started/substeps/DownloadTheDesktopApp.vue';
import InviteMembers from '~/components/growth_wizard/getting_started/substeps/InviteMembers.vue';
import PickProjects from '~/components/growth_wizard/getting_started/substeps/PickProjects.vue';
import ReviewScreenshots from '~/components/growth_wizard/getting_started/substeps/ReviewScreenshots.vue';
import ReviewTeamInsights from '~/components/growth_wizard/getting_started/substeps/ReviewTeamInsights.vue';
import SetMemberPaymentDetails from '~/components/growth_wizard/getting_started/substeps/SetMemberPaymentDetails.vue';
import SubmitATimesheet from '~/components/growth_wizard/getting_started/substeps/SubmitATimesheet.vue';
import SubscribeToAReport from '~/components/growth_wizard/common/substeps/SubscribeToAReport.vue';
import TrackTime from '~/components/growth_wizard/getting_started/substeps/TrackTime.vue';
import ViewUnusualActivity from '~/components/growth_wizard/getting_started/substeps/ViewUnusualActivity.vue';
import SetUpTimeLimits from '~/components/growth_wizard/getting_started/substeps/SetUpTimeLimits.vue';
import SetUpProject from '~/components/growth_wizard/getting_started/substeps/SetUpProject.vue';
import ReviewYourTeam from '~/components/growth_wizard/getting_started/substeps/ReviewYourTeam.vue';
import TrackTimeUsingDesktopApp from '~/components/growth_wizard/getting_started/substeps/TrackTimeUsingDesktopApp.vue';
import GetFamiliarWithHubstaff from '~/components/growth_wizard/getting_started/substeps/GetFamiliarWithHubstaff.vue';
import DownloadAndTrackTime from '~/components/growth_wizard/getting_started/substeps/DownloadAndTrackTime.vue';

export const SUBSTEP_COMPONENTS = {
  subscribe_to_a_report: {
    component: SubscribeToAReport,
    getProps: (vm) => ({
      reports: vm.substepData,
      substepStatus: vm.updatedCurrentSubstep?.status,
    }),
  },
  create_a_smart_notification: {
    component: CreateASmartNotification,
    getProps: (vm) => ({
      insightsTrialMonthlyPrice: vm.substepData.insights_trial_monthly_price,
      insightsTrialStarted: vm.substepData.insights_trial_started,
      notifications: vm.substepData.notifications,
      organization: vm.organization,
      substepStatus: vm.updatedCurrentSubstep?.status,
      source: 'getting_started_flow',
    }),
  },
  review_team_insights: {
    component: ReviewTeamInsights,
    getProps: (vm) => ({
      'insights-data': vm.substepData.insights_data,
      'team-members': vm.substepData.team_members,
      'selected-team-member': vm.substepData.selected_team_member,
    }),
  },
  view_unusual_activity: {
    component: ViewUnusualActivity,
    getProps: (vm) => ({
      members: vm.substepData.members,
      'total-members': vm.substepData.total_members,
      'total-instances': vm.substepData.total_instances,
      'total-time': vm.substepData.total_time,
    }),
  },
  review_screenshots: {
    component: ReviewScreenshots,
    getProps: (vm) => ({
      'team-members': vm.substepData.team_members,
      'team-member-activities': vm.substepData.team_member_activities,
      'selected-team-member': vm.substepData.selected_team_member,
    }),
  },
  approve_a_timesheet: {
    component: ApproveATimesheet,
    getProps: (vm) => ({
      activities: vm.substepData.activities,
      'team-members': vm.substepData.team_members,
      'selected-team-member': vm.substepData.selected_team_member,
    }),
  },
  approve_a_time_off_request: {
    component: ApproveATimeOffRequest,
    getProps: (vm) => ({
      'time-off-requests': vm.substepData.time_off_requests,
    }),
  },
  pick_projects: {
    component: PickProjects,
    getProps: (vm) => ({
      projects: vm.substepData.projects,
      organization: vm.organization,
      'current-user': vm.currentUser,
    }),
  },
  create_teams: {
    component: CreateTeams,
    getProps: (vm) => ({
      teams: vm.substepData,
      organization: vm.organization,
    }),
  },
  invite_members: {
    component: InviteMembers,
    getProps: (vm) => ({
      invites: vm.substepData.invites || [],
      inviteUrl: vm.substepData.invite_url,
      organization: vm.organization,
      quickstartVideoUrl: vm.substepData.quickstart_video_url,
      employeeEngagementToolkitUrl: vm.substepData.employee_engagement_toolkit_url,
      reloadSubstep: () => vm.reloadSubstep(),
      completeSubstep: () => vm.completeSubstep(),
    }),
  },
  set_member_payment_details: {
    component: SetMemberPaymentDetails,
    getProps: (vm) => ({
      organization: vm.organization,
      users: vm.substepData.users,
      invites: vm.substepData.invites,
      'timesheet-approvals-available': vm.substepData.timesheet_approvals_available
    }),
  },
  connect_payroll: {
    component: ConnectPayroll,
    getProps: (vm) => ({
      integrations: vm.substepData,
    }),
  },
  add_a_holiday: {
    component: AddAHoliday,
    getProps: (vm) => ({
      organization: vm.organization,
      holidays: vm.substepData.holidays,
    }),
  },
  track_time: {
    component: TrackTime,
    getProps: (vm) => ({
      projects: vm.substepData.projects,
    }),
  },
  submit_a_timesheet: {
    component: SubmitATimesheet,
    getProps: (vm) => ({
      timesheets: vm.substepData.timesheets,
    }),
  },
  download_the_desktop_app: {
    component: DownloadTheDesktopApp,
    getProps: (vm) => ({
      'download-url': vm.substepData.download_url,
      gated: vm.substepData.gated,
    }),
  },
  download_and_track_time: {
    component: DownloadAndTrackTime,
    getProps: (vm) => ({
      downloadUrl: vm.substepData.download_url,
      downloadDialog: vm.substepData.download_dialog,
      userOrganizationId: vm.substepData.user_organization_id,
      downloadConfirmed: vm.substepData.download_confirmed,
      timeTracked: vm.substepData.time_tracked,
      hasProject: vm.substepData.has_project,
      quickStartGuideUrl: vm.substepData.quick_start_guide_url,
      reloadSubstep: () => vm.getSubstepData(),
    }),
  },
  track_time_using_desktop_app: {
    component: TrackTimeUsingDesktopApp,
    getProps: () => ({}),
  },
  get_familiar_with_hubstaff: {
    component: GetFamiliarWithHubstaff,
    getProps: (vm) => ({
      'storylane-url': vm.substepData.storylane_url,
    }),
  },
  set_up_time_limits: {
    component: SetUpTimeLimits,
    getProps: (vm) => ({
      organization: vm.organization,
      'global-limits': vm.substepData.global_limits,
      members: vm.substepData.members,
    }),
  },
  review_your_team: {
    component: ReviewYourTeam,
    getProps: (vm) => ({
      teamMembers: vm.substepData.team_members,
      teamMemberStats: vm.substepData.team_member_stats,
      teamMemberDays: vm.substepData.team_member_days,
    }),
  },
  set_up_project: {
    component: SetUpProject,
    getProps: (vm) => ({
      project: vm.substepData.project,
      clients: vm.substepData.clients,
      organization: vm.organization,
      hideBudgetCard: vm.substepData.hide_budget_card,
      currentUser: vm.currentUser,
    }),
  },
};
